export const BASENAME = process.env.REACT_APP_BASENAME ? process.env.REACT_APP_BASENAME : '';

// Auth Routes
export const LOGIN_ROUTE = '/auth/login';
export const EMAIL_LOGIN_ROUTE = '/auth/email/login';
export const PROFILE_VIEW = '/profile';
export const PROFILE_EDIT = '/profile/edit';
export const BADGING_LOGIN_ROUTE = '/auth/badging/login/:id/:installationId/:airportCode';
export const TRAINING_MANAGEMENT_SECTION_DETAILS = '/training/section/start/';
export const PORTAL = '/training';
export const ADP_APPLICATION = '/auth/adp/login/:installationId/:id/:airportCode';
export const ADP = '/auth/adp/login/:installationId';
export const MYFORMS = '/myforms';
export const DOCUMENTS = '/documents';
export const INSPECTIONS = '/MyInspections';
export const GROSSRECIEPTS = '/gross_receipts';
